// Import and register all your controllers
import { application } from "./application"

// Import main controllers
import AccountsController from "./accounts_controller"
import AutoScrollController from "./auto_scroll_controller"
import AutogrowController from "./autogrow_controller"
import BulkController from "./bulk_controller"
import ClipboardController from "./clipboard_controller"
import MentionsController from "./mentions_controller"
import NotificationsController from "./notifications_controller"
import PrelineController from "./preline_controller"
import PricingController from "./pricing_controller"
import ThemeController from "./theme_controller"
import TooltipController from "./tooltip_controller"
import OpeningHoursController from "./opening_hours_controller"
import FilterableSelectController from "./filterable_select_controller"
import StatsTimeframeController from "./stats_timeframe_controller"

// Import bridge controllers
import BridgeFormController from "./bridge/form_controller"
import BridgeMenuButtonController from "./bridge/menu_button_controller"
import BridgeNotificationBadgeController from "./bridge/notification_badge_controller"
import BridgeNotificationTokenController from "./bridge/notification_token_controller"
import BridgeSignOutController from "./bridge/sign_out_controller"

// Register main controllers
application.register("accounts", AccountsController)
application.register("auto-scroll", AutoScrollController)

import AutoAnimateController from "./auto_animate_controller"
application.register("auto-animate", AutoAnimateController)
application.register("autogrow", AutogrowController)
application.register("bulk", BulkController)
application.register("clipboard", ClipboardController)
application.register("mentions", MentionsController)
application.register("notifications", NotificationsController)
application.register("preline", PrelineController)
application.register("pricing", PricingController)
application.register("theme", ThemeController)
application.register("tooltip", TooltipController)
application.register("opening-hours", OpeningHoursController)
import StreamingMarkdownController from "./streaming_markdown_controller"
application.register("streaming-markdown", StreamingMarkdownController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatSuggestionsController from "./chat_suggestions_controller"
application.register("chat-suggestions", ChatSuggestionsController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import PromptsSwiperController from "./prompts_swiper_controller"
application.register("prompts-swiper", PromptsSwiperController)

import ExpandablePromptsController from "./expandable_prompts_controller"
application.register("expandable-prompts", ExpandablePromptsController)

import EmbedLockController from "./embed_lock_controller"
application.register("embed-lock", EmbedLockController)

import AggridController from "./aggrid_controller"
application.register("aggrid", AggridController)

import SuggestedQuestionsController from "./suggested_questions_controller"
application.register("suggested-questions", SuggestedQuestionsController)

import GenerateQuestionsController from "./generate_questions_controller"
application.register("generate-questions", GenerateQuestionsController)

import FingerprintController from "./fingerprint_controller"
application.register("fingerprint", FingerprintController)
application.register("stats-timeframe", StatsTimeframeController)

import SparklineController from "./sparkline_controller"
application.register("sparkline", SparklineController)

import ExpertQaController from "./expert_qa_controller"
application.register("expert-qa", ExpertQaController)

import CartCommandController from "./cart_command_controller"
application.register("cart-command", CartCommandController)

import CopyJourneyController from "./copy_journey_controller"
application.register("copy-journey", CopyJourneyController)

import ProductActionsController from "./product_actions_controller"
application.register("product-actions", ProductActionsController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import ProductComboboxController from "./product_combobox_controller"
application.register("product-combobox", ProductComboboxController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import AiSummaryTrackingController from "./ai_summary_tracking_controller"
application.register("ai-summary-tracking", AiSummaryTrackingController)

import SummaryRefineController from "./summary_refine_controller"
application.register("summary-refine", SummaryRefineController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import ImageGalleryController from "./image_gallery_controller"
application.register("image-gallery", ImageGalleryController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ProposalProductSelectController from "./proposal_product_select_controller"
application.register("proposal-product-select", ProposalProductSelectController)

import SearchResultsEmbedController from "./search_results_embed_controller"
application.register("search-results-embed", SearchResultsEmbedController)

import AiEmbedController from "./ai_embed_controller"
application.register("ai-embed", AiEmbedController)

import ProposalEmbedController from "./proposal_embed_controller"
application.register("proposal-embed", ProposalEmbedController)

import AiFormAssistController from "./ai_form_assist_controller"
application.register("ai-form-assist", AiFormAssistController)

import AvatarPickerController from "./avatar_picker_controller"
application.register("avatar-picker", AvatarPickerController)

import CharCounterController from "./char_counter_controller"
application.register("char-counter", CharCounterController)

import NinjaKeysController from "./ninja_keys_controller"
application.register("ninja-keys", NinjaKeysController)

// Register bridge controllers
application.register("bridge--form", BridgeFormController)
application.register("bridge--menu-button", BridgeMenuButtonController)
application.register("bridge--notification-badge", BridgeNotificationBadgeController)
application.register("bridge--notification-token", BridgeNotificationTokenController)
application.register("bridge--sign-out", BridgeSignOutController)

// Import and register Tailwind Stimulus Components
import {
  Alert,
  Dropdown,
  Modal,
  Tabs,
  Popover,
  Toggle,
  Slideover,
} from "tailwindcss-stimulus-components"

application.register("alert", Alert)
application.register("dropdown", Dropdown)
application.register("modal", Modal)
application.register("tabs", Tabs)
application.register("popover", Popover)
application.register("toggle", Toggle)
application.register("slideover", Slideover)

export { application }